<!--
    TermsPage.svelte
-->

<script>
	import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';

    onMount(() => {
    })

</script>

<style>

    .terms-page {
        font-size: 1.2em;
        font-weight: 100;
    }

    .terms-page h3 {
        font-size: 1.3em;
        color: var(--tcare-primary);
    }

    .terms-page a {
        font-weight: normal;
        color: var(--tcare-primary);
    }

    .terms-page a:hover {
        color: var(--tcare-secondary);
    }

</style>

<div class="page-content terms-page" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">
    <div class="spacer-h-25"></div>
    <PageBanner title="TCARE Connect Terms of Service"/>
    <div class="spacer-h-25"></div>

    <div>
        <h3>Cookies</h3>
        TCARE does online advertising across the Internet. Some of our business partners, including Google, place cookies 
        on our website for remarketing and serving ads on various websites based on someone's past visits to our website. 
        You can opt out of Google's use of cookies by visiting Google's Ads Settings.
        
        <h3>Links</h3>
        This web site contains links to other sites. We are not responsible for the content or privacy practices of these 
        other sites. We encourage you to be aware of when you leave our site and to read the privacy statements of any 
        other site that collects personally identifiable information.
        
        <h3>Updates</h3>
        Our Privacy Policy may change periodically and updates will be posted on this page. If you feel that we are not 
        abiding by this privacy policy, you should contact us immediately at <a href='contact@tcare.ai'>contact@tcare.ai</a>
        

        This privacy policy discloses the privacy practices for www.tcare.ai 
        and applies solely to information collected by this web site.

        <h3>Information Collection, Use and Sharing</h3>
        We are the sole owners of the information collected on this site. We only have access to/collect information that 
        you voluntarily give us via email or other direct contact. We will not sell or rent this information to anyone.

        Only employees who need your information to perform a specific job (for example, customer servicing) have access 
        to personally identifiable information. We will use your information to respond to you, regarding the reason you 
        contacted us.

        We will not share your information with any third party outside of our organization, other than as necessary to 
        fulfill a request you may have.

        Unless you ask us not to, we may contact you via email in the future to tell you about (for example) new products 
        or services, or changes to this privacy policy.

        <h3>Your Access to and Control over Information</h3>
        You can do the following by contacting us at <a href='hello@tcare.ai'>hello@tcare.ai</a>
    
        - See what data we have about you, if any.
        - Change/correct any data we have about you.
        - Have us delete any data we have about you.
        - Express any concern you have about our use of your data.
        - Opt out of any future contacts from us.
    
        
    </div>

    <br/><br/>

</div>

